import { createApp } from "vue";
import AhMessage from "../components/AhMessage.vue";

// 创建一个 DOM 容器来挂载消息管理器
const container = document.createElement("div");
document.body.appendChild(container);

// 创建并挂载消息管理器实例
const app = createApp(AhMessage);
const instance = app.mount(container);

// 封装全局调用方法
const AhMessageApi = {
    success(message, duration = 3000) {
        instance.addMessage(message, "success", duration);
    },
    error(message, duration = 3000) {
        instance.addMessage(message, "error", duration);
    },
    warning(message, duration = 3000) {
        instance.addMessage(message, "warning", duration);
    },
    info(message, duration = 3000) {
        instance.addMessage(message, "info", duration);
    },
};

export default AhMessageApi;